import { CurrentCompany } from "@/types";

/**
 * Self-registered, invited and rejected companies are locked until Reviver approves them, and their users get the
 * awaiting-approval page instead of the app. `isLocked` keeps out old unapproved companies that are in normal use.
 */
export const isCompanyAwaitingApproval = (company?: Partial<CurrentCompany> | null) =>
  !!company?.isLocked && company.approvedByAdmin === false;

/**
 * The session points at a company whose details haven't loaded yet. Until they do, nobody can tell whether it awaits
 * approval, so the app waits instead of rendering pages (and firing their requests) for it.
 */
export const isCompanyContextLoading = (
  sessionCompanyId: number | null | undefined,
  currentCompany: Partial<CurrentCompany> | undefined,
  companiesFailed: boolean
) => !!sessionCompanyId && currentCompany === undefined && !companiesFailed;
